/* NIM-4056 — The Plug popup behaviour on the unpublished theme copy only.
   1. A "No thanks" text link at the bottom of the card that dismisses through the
      popup's own close button (so the platform records the dismissal as usual).
   2. Single-choice questions advance on tap: choosing a pill submits that step
      through the form's own submit handler; the Next button is then hidden by CSS.
   Both are stopgaps for native options in benefit-quiz.js (platform item). */
(function () {
  function wire(panel) {
    if (!panel || panel.__nqpWired) return;
    panel.__nqpWired = true;
    panel.classList.add('nqp-auto');
    var close = panel.querySelector('.nq-pop__close');
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'nqp-nothanks';
    link.textContent = 'No thanks';
    link.addEventListener('click', function () { if (close) close.click(); });
    panel.appendChild(link);
    // Only on the question step; the email and code steps keep just the close button.
    function sync() { link.hidden = !panel.querySelector('.nq__fieldset'); }
    sync();
    new MutationObserver(sync).observe(panel, { childList: true, subtree: true });
    panel.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !t.checked) return;
      var form = t.form;
      if (!form || form.classList.contains('nq__email')) return;
      setTimeout(function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }, 180);
    });
  }
  function scan() { wire(document.querySelector('.nq-pop__panel')); }
  if (!('MutationObserver' in window)) return;
  var mo = new MutationObserver(function () {
    var p = document.querySelector('.nq-pop__panel');
    if (p) { wire(p); mo.disconnect(); }
  });
  function start() { scan(); if (!document.querySelector('.nq-pop__panel')) mo.observe(document.body, { childList: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
